import React from "react";
import { Link } from "react-router-dom";

const WaterQualityDevice = ({
  deviceStatus,
  deviceId,
  codValue,
  bodValue,
  tssValue,
  phValue,
  tempValue,
  lastUpdated,
  powerStatus,
  title,
  date,
  isExpired,
  onPinClick,
  pinned,
  index,
}) => {
  return (
    <div className="device-card water-quality-card">
      <div className="device-header">
        <div className="device-title">
          <h5>{title}</h5>
          <p className="device-date">{date}</p>
        </div>
        <div className="device-actions">
          <button
            className={`pin-btn ${pinned ? "pinned" : ""}`}
            onClick={onPinClick}
            title={pinned ? "Unpin" : "Pin"}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </button>
        </div>
      </div>

      <div className="device-content">
        {isExpired ? (
          <div className="expired-message">
            <div className="expired-icon">
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
              </svg>
            </div>
            <p>Subscription Expired</p>
          </div>
        ) : (
          <>
            {/* Gas Animation Container */}
            <div className="gas-animation-container">
              <div className="gas-bubbles">
                <div className="bubble bubble-1"></div>
                <div className="bubble bubble-2"></div>
                <div className="bubble bubble-3"></div>
                <div className="bubble bubble-4"></div>
                <div className="bubble bubble-5"></div>
                <div className="bubble bubble-6"></div>
              </div>
              <div className="gas-tank">
                <div className="gas-level"></div>
                <div className="gas-molecules">
                  <div className="molecule molecule-1"></div>
                  <div className="molecule molecule-2"></div>
                  <div className="molecule molecule-3"></div>
                </div>
              </div>
            </div>

            {/* Water Quality Parameters */}
            <div className="water-quality-parameters">
              <div className="parameter-row">
                <div className="parameter">
                  <span className="parameter-label">COD</span>
                  <span className="parameter-value">{codValue || "--"}</span>
                </div>
                <div className="parameter">
                  <span className="parameter-label">BOD</span>
                  <span className="parameter-value">{bodValue || "--"}</span>
                </div>
              </div>
              <div className="parameter-row">
                <div className="parameter">
                  <span className="parameter-label">TSS</span>
                  <span className="parameter-value">{tssValue || "--"}</span>
                </div>
                <div className="parameter">
                  <span className="parameter-label">pH</span>
                  <span className="parameter-value">{phValue || "--"}</span>
                </div>
              </div>
              <div className="parameter-row">
                <div className="parameter">
                  <span className="parameter-label">Temp</span>
                  <span className="parameter-value">{tempValue || "--"}</span>
                </div>
                <div className="parameter">
                  <span className="parameter-label">Status</span>
                  <span
                    className={`status-indicator ${
                      deviceStatus === "active" ? "active" : "inactive"
                    }`}
                  >
                    {deviceStatus === "active" ? "Online" : "Offline"}
                  </span>
                </div>
              </div>
            </div>

            {/* Device Status */}
            <div className="device-status">
              <div className="status-item">
                <span className="status-label">Last Updated:</span>
                <span className="status-value">{lastUpdated || "--"}</span>
              </div>
              <div className="status-item">
                <span className="status-label">Battery:</span>
                <span
                  className={`battery-status ${powerStatus ? "good" : "low"}`}
                >
                  {powerStatus ? "Good" : "Low"}
                </span>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Action Buttons */}
      <div className="device-actions">
        <Link to={`/device-detail/${deviceId}`} className="action-btn primary">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
          View Details
        </Link>
        <Link to="/report" className="action-btn secondary">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
          </svg>
          Reports
        </Link>
      </div>
    </div>
  );
};

export default WaterQualityDevice;
